import { render, staticRenderFns } from "./ManagementAddContractorInfoResume.vue?vue&type=template&id=68e1c99d"
import script from "./ManagementAddContractorInfoResume.vue?vue&type=script&lang=ts"
export * from "./ManagementAddContractorInfoResume.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68e1c99d')) {
      api.createRecord('68e1c99d', component.options)
    } else {
      api.reload('68e1c99d', component.options)
    }
    module.hot.accept("./ManagementAddContractorInfoResume.vue?vue&type=template&id=68e1c99d", function () {
      api.rerender('68e1c99d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ManagementAddContractorInfoResume.vue"
export default component.exports